<template>
    <div class="full-screen-mask">
        <div class="pop-up-box" :class="textAlign">
            <infiniteLoading spinner="spiral" class="loading" v-if="loading"></infiniteLoading>
            <p class="title">{{ title }}</p>
            <p class="description">{{ description }}</p>
            <ul class="button-list">
                <li
                    v-for="(button, index) in buttons"
                    :key="index"
                    :class="button.type"
                    @click="btnClick(button)"
                >{{ button.text }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
    components: {
        InfiniteLoading
    },
    props: {
        textAlign: String,
        title: String,
        description: String,
        buttons: Array,
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        btnClick ( btn ) {

            if ( btn.click ) {

                this.$emit( btn.click, btn );

            }

        }
    }
};
</script>
<style lang="less" scoped>
.full-screen-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    font-size: 0;
    z-index: 10;
}
.pop-up-box {
    width: 640px;
    padding: 50px 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.24rem;
    background-color: #fff;
    box-sizing: border-box;
    overflow: hidden;

    @media @mobile {
        width: calc(100% - 0.6rem);
        padding: 1rem 0.6rem 0.6rem;
    }
    .loading {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255,255,255,.7);
    }
    .title {
        font-size: 20px;
        font-weight: 700;
        color: #333333;

        @media @mobile {
            font-size: 0.46rem;
        }

        &:not(:empty) + .description:not(:empty) {
            margin-top: 20px;

            @media @mobile {
                margin-top: 0.6rem;
            }
        }
    }
    .description {
        font-size: 18px;
        font-weight: 400;
        color: #777777;

        @media @mobile {
            font-size: 0.46rem;
        }
    }
    &.center {
        .title,
        .description {
            text-align: center;
        }
    }
    &.left {
        .title,
        .description {
            text-align: left;
        }
    }
}
.button-list {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    text-align: center;

    @media @mobile {
        margin-top: 1rem;
    }
    li {
        font-size: 16px;
        font-weight: 700;
        width: 100%;
        cursor: pointer;

        @media @mobile {
            font-size: 0.34rem;
        }
        &.normal {
            color: #333333;
        }
        &.warning {
            color: #ff5e62;
        }
        &.primary {
            color: #009de1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popUp.vue